export enum LeadProducts{
    Yongo = 'Yongo',
    Uppie = 'Uppie',
    Zennie = 'Zennie'
}

export enum ProductCodeRange{
    Uppie = 1,
    Zennie = 2,
    Yongo = 4,
    Yongo1 = 5
}

export enum ConsentType{
  SilInvestmentMonitoringEmailsConsent = 1,
  SilPromotionalEmailsConsent = 2,
  SilMarketingConsent = 3,
  PartnerConsent = 4
}

export const ProductModules = {
  Uppie: 2,
  Zennie: {
    Eligibility: 1,
    QuoteCreation: 2
  }
}